import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BookingChainMarks } from '@services/api/booking/booking-chain.model';
import { TooltipModule } from 'primeng/tooltip';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

@Component({
  selector: 'app-chain-marks',
  standalone: true,
  imports: [TranslateModule, TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (marks()?.isExtended) {
      <span
        class="inline-flex items-center gap-1 rounded bg-indigo-100 px-2 py-1 text-xs font-semibold text-indigo-800"
        [attr.aria-label]="'booking.chain.badge.extended' | translate"
        [pTooltip]="positionTooltip()"
        tooltipPosition="top"
      >
        <i class="pi pi-link text-[11px]" aria-hidden="true"></i>
        <span class="hidden sm:inline">{{ 'booking.chain.badge.extended' | translate }}</span>
      </span>
    }
    @if (marks()?.isExtension) {
      <span
        class="inline-flex items-center gap-1 rounded bg-amber-100 px-2 py-1 text-xs font-semibold text-amber-800"
        [attr.aria-label]="'booking.chain.badge.extension' | translate"
        [pTooltip]="positionTooltip()"
        tooltipPosition="top"
      >
        <i class="pi pi-link text-[11px]" aria-hidden="true"></i>
        <span class="hidden sm:inline">{{ 'booking.chain.badge.extension' | translate }}</span>
      </span>
    }
  `
})
export class ChainMarksComponent {
  readonly marks = input<BookingChainMarks | undefined>();

  private readonly translateService = inject(TranslateService);

  readonly positionTooltip = computed(() => {
    const position = this.marks()?.position;
    return position ? this.translateService.instant('booking.chain.badge.position', position) : '';
  });
}
